
    import { Options, Vue } from 'vue-class-component';
    import { mapState } from 'vuex';
    // Import Swiper Vue.js components
    import { Swiper, SwiperSlide } from 'swiper/vue';

    // import required modules
    import { Navigation, Pagination, Mousewheel, Keyboard } from 'swiper';
    import { Project } from '@/models/Project';
    import { computed } from '@vue/runtime-core';
    import { Newsletter } from '@/models/Newsletter';
    import { PageModel } from '@/models/SMS';
    import _ from 'lodash';

    @Options<CarouselComponent>({
        props: {
            name: String,
        },
        components: {
            Swiper,
            SwiperSlide,
        },
        computed: {
            ...mapState(['Pages', 'Newsletters', 'BlobEndPoint']),
        },
    })
    export default class CarouselComponent extends Vue {
        public Pages!: Project[];
        public PagesArray: PageModel[] = [];
        public Newsletters!: Newsletter[];
        public BlobEndPoint!: string;
        public countOfLinksOnPage = 9;
        public selectedPage: PageModel | null = null;
        public pagination = {
            clickable: true,
        };
        mounted(): void {
            this.PagesArray = this.Pages.filter((x) => x.Link).map((page, index) => {
                const newPage = new PageModel();
                newPage.Id = page.Id;
                newPage.Name = page.Name;
                newPage.Title = page.Title;
                newPage.Link = page.Link;
                newPage.PreviewPath = this.BlobEndPoint + 'pages/' + page.Id + '/preview.jpg';
                newPage.UpdatedAt = page.UpdatedAt;
                return newPage;
            });
        }
        get SlidePages() {
            return _.chunk(this.PagesArray, this.countOfLinksOnPage);
        }
        public modules = [Navigation, Pagination, Mousewheel, Keyboard];
        public selectPage(page: Project) {
            this.selectedPage = page;
            this.$emit('pageSelected', this.selectedPage.Link);
            this.$emit('onSelected', this.selectedPage);
        }
    }
